import { render, staticRenderFns } from "./ProductCategoryModalForm.vue?vue&type=template&id=5f1112ec"
import script from "./ProductCategoryModalForm.vue?vue&type=script&lang=js"
export * from "./ProductCategoryModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports